import { Link, useSearchParams } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { CheckPaymentStatus } from "../../services/client/payment/checkStatus";

const PaymentStatus = () => {
    const [searchParams] = useSearchParams();
    const success = searchParams.get("success");
    const status: any = searchParams.get("status");
    const trackId = searchParams.get("trackId");
    const isReady = success && status && trackId;
    const { data } = useQuery({
        queryKey: ["check-payment-status", success, status, trackId],
        queryFn: () =>
            CheckPaymentStatus({
                success,
                status,
                trackId,
            }),
        enabled: !!isReady,
    });
    return (
        <>
            {data?.data?.ref_number && status == 2 ? (
                <>
                    <div className="py-5 my-5">
                        <div className="d-flex justify-content-center">
                            <img alt="icon" src={require('./../../assets/media/global/sucess.png')} style={{ width: '100px', height: '100px', objectFit: 'cover' }} />
                        </div>
                        <p className="text-center text-site fw-bold mt-3">
                            شماره پیگیری : {data?.data?.ref_number}
                        </p>
                        <p className="text-center fw-bold mt-3">
                            .پرداخت شما با موفقیت انجام شد
                        </p>
                        <div className="d-flex justify-content-center">
                            <Link to={'/user/orders'} className="btn btn-primary">
                                بازگشت به سایت
                            </Link>
                        </div>
                    </div>
                </>
            ) : (
                <>
                    <>
                        <div className="py-5 my-5">
                            <div className="d-flex justify-content-center">
                                <img alt="icon" src={require('./../../assets/media/global/errorPay.png')} style={{ width: '100px', height: '100px', objectFit: 'cover' }} />
                            </div>
                            <p className="text-center fw-bold mt-3">
                                .پرداخت شما با شکست مواجه شد
                            </p>
                        </div>
                    </>
                </>
            )}
        </>
    );
};

export default PaymentStatus;
